const WORDS = [
  "Pipeline clarity",
  "Forecast accuracy",
  "Signal capture",
  "Deal velocity",
  "Revenue intelligence",
  "Zero guesswork",
];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <section data-testid="marquee" className="relative border-y border-white/10 py-6 bg-ink-2 overflow-hidden">
      <div className="marquee-track">
        {items.map((w, i) => (
          <span
            key={i}
            className="flex items-center gap-8 px-8 font-display font-semibold text-3xl md:text-5xl text-paper/80"
          >
            {w}
            <span className="text-acid text-2xl">✳</span>
          </span>
        ))}
      </div>
    </section>
  );
};
